function money(value){

return "PKR " + value.toLocaleString();

}

function launchConfetti(){

for(let i=0;i<120;i++){

const c=document.createElement("div");

c.className="confetti";

c.style.left=Math.random()*100+"vw";

c.style.background=["#6A0017","#ffffff","#A51D3A","#D4AF37"][Math.floor(Math.random()*4)];

c.style.animationDelay=(Math.random()*0.6)+"s";

document.body.appendChild(c);

setTimeout(()=>c.remove(),3000);

}

}

let fired=false;

async function updateShippingBar(){

const res=await fetch('/cart.js');

const cart=await res.json();

const goal=4500;

const total=cart.total_price/100;

const remaining=Math.max(goal-total,0);

const percent=Math.min((total/goal)*100,100);

const fill=document.querySelector(".shipping-progress-fill");

const msg=document.querySelector(".shipping-message");

if(!fill||!msg) return;

fill.style.width=percent+"%";

if(total>=goal){

msg.innerHTML='<span class="shipping-success">🎉 CLOCK IT! You\'ve unlocked FREE shipping! Aura +100000 fr.</span>';

if(!fired){

launchConfetti();

fired=true;

}

}else{

msg.innerHTML='You are <strong>'+money(remaining)+'</strong> away from <strong>FREE shipping</strong>, detective!';

fired=false;

}

}

document.addEventListener("DOMContentLoaded",()=>{

updateShippingBar();

});

document.addEventListener("cart:updated",()=>{

updateShippingBar();

});

document.addEventListener("change",()=>{

setTimeout(updateShippingBar,300);

});

setInterval(updateShippingBar,1200);